import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {ifDefined} from 'lit/directives/if-defined.js';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('slds-search')
class SldsSearch extends SldsBaseElement {
  @property({type: Boolean}) opened = false;
  @property({type: Boolean}) loading = false;
  @property({type: Boolean}) showMenu = false;
  @property({type: Boolean}) hasResults = false;
  @property({type: Array}) stencils = [0,1,2,3,4,5,6,7];
  @property({type: Array}) items = [];
  @property({type: String}) searchText = '';

  constructor() {
    super();
    document.addEventListener('click', (function(e) {
      const path = e.composedPath();
      let insideMenuClick = false;
      if(!(path === undefined || path.length == 0)) {
       insideMenuClick = path.find((el) => { return el == this; });
      }
      if(insideMenuClick) {
        //inside element
      } else if (this.opened) {
        //outside element
        this.opened = false;
        const event = new CustomEvent('blur', { open: this.opened, bubbles: true });
        this.dispatchEvent(event);
      }
    }).bind(this), false);
    document.addEventListener('keydown', (function(e) {
      if(e.keyCode == 27 && this.opened) {
        this.opened = false;
      }
    }).bind(this));
  }

  changeItems(items) {
    this.items = items;
    this.requestUpdate();
  }

  updated(changedProperties) {
    if (changedProperties.has('items')) {
      if (this.items) {
        if (this.items.length === 0 && this.searchText === '') {
          this.hasResults = false;
          this.showMenu = false;
        } else {
          this.hasResults = true;
          this.showMenu = true;
        }
        this.requestUpdate();
        this.loading = false;
      }
    }
  }

  onChange(e) {
    // Check if the key is a single printable character
    if (e.key && e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
      // console.log('Character key pressed:', e.key);
    } else {
      // if (e.key === 'Backspace') {
      //   this.searchText = this.searchText.slice(0, -1);
      //   if (this.searchText.length === 0) {
      //     this.showMenu = false;
      //   }
      // }
      // console.log('Non-character key pressed:', e.key);
      // return null;
    }
    this.loading = true;
    this.hasResults = false;
    const text = e.target.value;
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.showMenu = true;
    this.searchText = text;
    // Introduce debouncer with 200ms delay
    this.debounceTimeout = setTimeout((() => {
      this.dispatchEvent(new CustomEvent('search', { bubbles: true, detail: text }));
    }).bind(this), 200);
  }

  toggle() {
    this.opened = !this.opened;
    if(this.opened) {
      setTimeout((function(){
        this.shadowRoot.querySelector("#filterId").focus();
      }).bind(this), 50);
    }
  }

  stencilCss(index) {
    return "opacity:"+((this.stencils.length - index)/this.stencils.length)+";";
  }

  select(e) {
    e.target.select();
  }

  stripEms(text) {
    return text.split('<pre>').join('').split('</pre>').join('');
  }

  getHighlightFragment(text, fragmentNumber) {
    const fragments = text.split(/<\/?pre>/);
    return fragments[fragmentNumber] || '';
  }

  static styles = [
    super.styles,
    css`
      .width-filler {
        height: 0.575rem;
        /* width: 22.5rem; */
      }
    input {
      --slds-c-input-text-color: #181818;
      --sds-c-input-text-color: #181818;
    }
    .dark input {
      --slds-c-input-color-border: #514f4d;
      --slds-c-input-text-color: white;
      --sds-c-input-text-color: white;
    }
    .dark .slds-panel {
      background: #2b2826;
    }
    #treeheading { 
      color: var(--text-color, #181818);
    }
    .stencil span {
      visibility: hidden;
    }
    .stencil div.slds-tree__item {
      background-color: lightgray !important;
      margin: 1rem;
      border-radius: 1rem;
      padding: 0.275rem 0 0.275rem 1rem;
    }
    .slds-icon {
      --slds-c-icon-color-foreground: currentColor;
    }
    [hidden] {
      display: none;
    }
    .slds-panel {
      background-color: var(--background-color, white);
    }
    .slds-dropdown__item>a {
      color: var(--text-color, #181818);
    }
    .slds-dropdown__item>a:focus, .slds-dropdown__item>a:hover {
      background-color: var(--table-hover, #f3f3f3);
    }
    .slds-tree [aria-disabled=true] {
      color: var(--text-color, #181818);
    }
    pre {
      background-color: #fff03f;
      color: #181818;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    }
    `
  ];

  selectItem(e, item) {
    e.preventDefault();
    this.opened = false;
    this.dispatchEvent(new CustomEvent('select', { bubbles: true, detail: item }));
  }
  
  clear(e) {
    e.preventDefault();
    this.shadowRoot.querySelector("#filterId").value = '';
    this.items = [];
    this.hasResults = false;
    this.searchText = '';
    this.loading = false;
    this.showMenu = false;
    this.toggle();
  }

  render() {
    return html`
      <a hidden="${ifDefined(this.opened ? this.opened : undefined)}" href="javascript:void(0);" @click="${this.toggle}" class="slds-builder-header__item-action slds-media slds-media_center">
        <span class="slds-media__figure">
          <span class="slds-icon_container slds-icon-utility-settings slds-current-color">
            <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
            </svg>
          </span>
        </span>
        <span class="slds-media__body">
          <span class="slds-truncate" title="Search">Search</span>
        </span>
      </a>
      <div class="width-filler" hidden="${ifDefined(!this.opened ? this.opened : undefined)}"></div>
        <div hidden="${ifDefined(!this.opened ? this.opened : undefined)}" id="dropdown" class="slds-m-left_small slds-m-right_medium slds-grid slds-grid_vertical">
          <div class="slds-col">
            <div class="slds-m-bottom_small">
              <div class="slds-form-element">
                <label class="slds-form-element__label slds-assistive-text" for="filterId">Filter Results</label>
                <div class="slds-form-element__control slds-input-has-icon slds-input-has-icon_left-right">
                  <span class="slds-icon_container slds-icon-utility-search" title="Description of icon when needed">
                    <svg class="slds-icon slds-input__icon slds-input__icon_left slds-icon-text-default" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
                    </svg>
                    <span class="slds-assistive-text">Description of icon when needed</span>
                  </span>
                  <input type="search" aria-controls="tree-id" id="filterId" @keydown="${this.onChange}" @input="${this.onChange}" @focus="${this.select}" placeholder="Quick Find" class="slds-input" />
                  <button id="clearBtn" @click="${this.clear}" class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Clear">
                    <svg class="slds-button__icon slds-icon-text-light" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#clear"></use>
                    </svg>
                    <span class="slds-assistive-text">Clear</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-col">
            ${this.showMenu ? html`<div class="slds-tree_container slds-panel slds-size_medium slds-panel_docked slds-panel_docked-left slds-is-open slds-m-left_xx-small">
              <h4 class="slds-m-left_small slds-m-top_xx-small slds-tree__group-header" id="treeheading">Results</h4>
              <ul aria-labelledby="treeheading" class="slds-tree slds-m-bottom_x-small" id="tree-id" role="tree">
                ${this.loading ? html`
                  ${this.stencils.map((stencil, index) => html`
                    <li style="${this.stencilCss(index)}" class="stencil slds-is-disabled" aria-disabled="true" aria-level="1" role="treeitem">
                      <div class="slds-tree__item">
                        <span class="slds-has-flexi-truncate">
                          <span class="slds-tree__item-label slds-truncate" title="Stencil"></span>
                        </span>
                      </div>
                    </li>`)}
                ` : html`
                  ${this.hasResults && this.items.length == 0 ? html`
                    <li class="slds-is-disabled" aria-disabled="true" aria-level="1" role="treeitem">
                      <div class="slds-tree__item">
                        <span class="slds-has-flexi-truncate">
                          <span class="slds-tree__item-label slds-truncate slds-text-align_center slds-m-top_x-small slds-m-bottom_x-small" title="No results">No results</span>
                        </span>
                      </div>
                    </li>` : 
                    this.items.map((item, index) => html`
                    <li class="slds-dropdown__item" role="presentation">
                      <a href="#" @click="${(e) => this.selectItem(e, item)}" role="menuitem" tabindex="0">
                        <span class="slds-truncate" title="${this.stripEms(item.label)}">${this.getHighlightFragment(item.label, 0)}<pre>${this.getHighlightFragment(item.label, 1)}</pre>${this.getHighlightFragment(item.label, 2)}</span>
                      </a>
                    </li>
                    `)}
                `}
              </ul>
            </div>` : html``}
          </div>
        </div>
    `
  }
}